import { ERROR_REPORTING_ENABLED } from "../constants";
import rg4js from 'raygun4js';

const useErrorReporting = () => {

  const start = (errorReportingKey) => {
    if (!ERROR_REPORTING_ENABLED) return;

    rg4js('enableCrashReporting', true);
    rg4js('apiKey', errorReportingKey);
    rg4js('options', {
      allowInsecureSubmissions: false,
      ignoreAjaxAbort: true,
      ignoreAjaxError: false,
      debugMode: false,
      ignore3rdPartyErrors: true,
      wrapAsynchronousCallbacks: true,
      excludedHostnames: [],
      excludedUserAgents: ['HeadlessChrome'],
      disableErrorTracking: false,
      disablePulse: true
    });
    rg4js('boot');
  };

  const setContext = (user) => {
    if (!ERROR_REPORTING_ENABLED) return;

    try {
      rg4js('setUser', {
        identifier: user.username,
        isAnonymous: false,
        email: user.email,
        firstName: user.firstName,
        fullName: user.firstName + ' ' + user.lastName,
        uuid: String(user.userId)
      });

      rg4js('withCustomData', {
        userType: user.userType,
        roleNames: user.roleNames
      });
    } catch (e) {
      console.error(e);
    }
  };

  const clearContext = () => {
    if (!ERROR_REPORTING_ENABLED) return;

    try {
      rg4js('withCustomData', {});
      rg4js('setUser', {
        identifier: '',
        isAnonymous: true,
        email: '',
        firstName: '',
        fullName: '',
        uuid: ''
      });
    }
    catch(e) {
      console.error(e);
    }
  };

  const sendError = (error) => {
    if (!ERROR_REPORTING_ENABLED) return;

    try {
      rg4js('send', error);
    }
    catch(e) {
      console.error(e);
    }
  };

  return { start, setContext, clearContext, sendError };
};

export default useErrorReporting;
